
import githubSvg from './css/github.svg';
import linkedinSvg from './css/linkedin.svg';
import { Link } from 'react-router-dom'

export default function Home() {
return (
    <div className='content'>
      <div className="name">
        <h1 className={"shiny-text"} style={{ animationDuration: '1.5s' }} >James Wheeler</h1>
        <h2>Software Engineer</h2>
        <p>I build software solutions, work with big data, and work with machine learning</p>

        <div className="social-links">
          <Link to={"https://www.linkedin.com/in/james-samuel-wheeler/"}><img src={linkedinSvg} alt={"linkedin logo"}/></Link>
          <Link to={"https://github.com/FrezeeOfficial"}><img src={githubSvg} alt={"github logo"}/></Link>


        </div>
      </div>


    {/* <div className='about'>
      <p>I’m James Wheeler, a First-Class Computer Science graduate from Swansea University with a passion for building secure, high-performance software systems. My work bridges low-level development, networking, and machine learning — from designing malware classifiers in C++ and PyTorch to configuring enterprise-scale network infrastructures with Cisco and VMware.</p>
      <br/>
      <p>I enjoy tackling complex technical challenges and turning them into reliable, maintainable solutions. Whether it’s optimizing multithreaded code, architecting resilient server environments, or experimenting with machine learning models, I thrive on projects that push my problem-solving skills.</p>
      <br/>
      <p>Outside of academics, I’ve built a home lab to deepen my hands-on experience in networking, virtualization, and cybersecurity, and I enjoy collaborating on open-source projects where I can share knowledge and learn from others.</p>
      <br/>
      <p>I’m always eager to apply my skills in real-world environments, contribute to innovative teams, and continue growing as a software engineer. </p>
    </div> */}

</div>

)
}

